import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=0308aa0a&scoped=true"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=0308aa0a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308aa0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0308aa0a')) {
      api.createRecord('0308aa0a', component.options)
    } else {
      api.reload('0308aa0a', component.options)
    }
    module.hot.accept("./FileBrowser.vue?vue&type=template&id=0308aa0a&scoped=true", function () {
      api.rerender('0308aa0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/FileBrowser.vue"
export default component.exports